module.exports = __webpack_public_path__ + "img/medium-m.17085ae4.svg";